import React from 'react'
import './css/Home.css'
import HomeHero from '../components/HomeHero'
import HomeAbout from '../components/HomeAbout'
import Footer from '../components/Footer'
import HomeMap from '../components/HomeMap'
import HomePlanning from '../components/HomePlanning'
import HomeTestimonials from '../components/HomeTestimonials'
import { Helmet } from 'react-helmet-async'

function Home() {
  return (
    <div className='Home'>

        <Helmet>
          <title>No:1 best catering service in Kerala | Top Culinary Delights & Exceptional Value | Plaza Catering| Top catering services in Kerala | Best catering Services | catering nearby</title>
          <meta name='keywords' content='Best Catering Services in Kerala, best Catering Services, Catering Service, Top catering Services '/>
          <meta name='description' content='Meet the top catering services in Kerala at Plaza Catering! Experience delightful culinary sensations, outstanding ambience, and exceptional value. We offer hygienic and efficient service at the best economical rates. Customer satisfaction is our priority, delivered with warmth, friendliness, and fun! ' />
          <link rel='canonical' href='/' />
        </Helmet>

        <HomeHero />
        <HomeAbout />
        <HomePlanning />
        <HomeTestimonials />
        <HomeMap />
        <Footer />
    </div>
  )
}

export default Home